/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LogoutRequestDTO
 */
export interface LogoutRequestDTO {
    /**
     * 
     * @type {string}
     * @memberof LogoutRequestDTO
     */
    logoutRequestUrl?: string;
}

export function LogoutRequestDTOFromJSON(json: any): LogoutRequestDTO {
    return LogoutRequestDTOFromJSONTyped(json, false);
}

export function LogoutRequestDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): LogoutRequestDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'logoutRequestUrl': !exists(json, 'logoutRequestUrl') ? undefined : json['logoutRequestUrl'],
    };
}

export function LogoutRequestDTOToJSON(value?: LogoutRequestDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'logoutRequestUrl': value.logoutRequestUrl,
    };
}

